(function () {
    'use strict';
    angular
        .module('app')
        .directive('editEmails', editEmails);
    editEmails.$inject = ['$window'];
    function editEmails($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                editEmailsDialogShown: '=?'
            },
            controller: 'editEmails',
            templateUrl: 'app/editEmails/templates/editEmails.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();